export default "__VITE_ASSET__DG3BiBgW__"